import * as requestFromServer from "./SectionRenewalCrud";
import { callTypes, sectionRenewalSlice } from "./SectionRenewalSlice";

const {actions} = sectionRenewalSlice;

export const getStudents = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getStudents(queryParams)
    .then(response => {
      dispatch(actions.studentsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getSections = () => async dispatch => {
  return requestFromServer
    .getSections()
    .then(response => {
      dispatch(actions.sectionsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveSections = (term, datas) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveSections(term, datas)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const cleanSectionRenewalState = () => dispatch => {
  return dispatch(actions.sectionRenewalStateCleaned());
};